import { signInBgImage, signInIpadImage } from '@anytag/shared-assets';

export const SignInCover = () => (
  <div className="relative">
    <div
      className="h-full w-107 rounded-r-sm bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: `url(${signInBgImage})` }}
    />
    <img className="absolute top-1/2 right-0 translate-y-[-50%]" src={signInIpadImage} alt="dashboard ipad" />
  </div>
);
